module.exports = __webpack_public_path__ + "img/scratch-bg-image.35611e26.png";